<template>
    <div class="app-container">
      <BjPage ref="BjPage"
        :label-width="'80px'"
        :query-params="queryParams" :col-span="colSpan"
        :get-action="queryApi" :serial="false" :auto-fetch="false"
        :before-reset-search="beforeResetSearch"
        @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
        >
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('dateText')">
                <BjDateRangePicker v-model="queryParamsTime" :clearable="false" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :placeholder="$t('dateText')" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.Menu')" prop="menu">
                <BjSelectLov v-model="queryParams.menu" :option-list="menuList" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <template v-if="queryParams.menu === 'Invoice Review'">
            <el-col :span="colSpan"><el-form-item label="Invoice" prop="invoiceId"><el-input v-model.trim="queryParams.invoiceId" clearable @change="handleQuery" /></el-form-item></el-col>
            <el-col :span="colSpan"><el-form-item label="Transaction" prop="transNo"><el-input v-model.trim="queryParams.transNo" clearable @change="handleQuery" /></el-form-item></el-col>
            <el-col :span="colSpan"><el-form-item :label="$t('invoiceReview.client')" prop="clientCode"><el-input v-model.trim="queryParams.clientCode" clearable @change="handleQuery" /></el-form-item></el-col>
            <el-col :span="colSpan"><el-form-item :label="$t('invoiceReview.week')" prop="billingWeekStart"><el-date-picker v-model="queryParams.billingWeekStart" type="date" value-format="yyyy-MM-dd" @change="handleQuery" /></el-form-item></el-col>
            <el-col :span="colSpan"><el-form-item :label="$t('billingPage.Method')" prop="action"><el-select v-model="queryParams.action" clearable @change="handleQuery"><el-option v-for="action in reviewActions" :key="action" :label="action" :value="action" /></el-select></el-form-item></el-col>
          </template>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>

      <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" width="800px" :before-close="handleCancel">
          <operation-log-detail :content="jsonData" />
        </el-dialog>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { billApi } from '@/api';
  import moment from 'moment';
  import OperationLogDetail from '../invoiceReview/OperationLogDetail';

  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  export default {
    name: 'BusinessBillingOperationLog',
    components: { OperationLogDetail },
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 8,
        queryParams: {
            startTime: moment(start).format('YYYY-MM-DD'),
            endTime: moment(new Date()).format('YYYY-MM-DD'),
            menu: '',
            invoiceId: '', transNo: '', clientCode: '', billingWeekStart: '', action: '',
            size: 100
        },
        queryParamsTime: [start, new Date()],
        queryApi: params => {
          const query = { ...params };
          if (query.menu === 'Invoice Review' && query.invoiceId) { delete query.startTime; delete query.endTime; }
          return billApi.getOperationLogList(query);
        },
        reviewActions: ['UPDATE_QUANTITY', 'DELETE_TRANSACTION', 'MARK_REVIEWED', 'REVIEW_INVALIDATED'],
        labelList: [
          { label: this.$t('billingPage.Operator2'), prop: 'createdBy', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Menu'), prop: 'menu', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Method'), prop: 'method', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Content'), prop: 'content', isCheck: true, disabled: false },
          { label: this.$t('billingPage.OperateTime'), prop: 'gmtCreate', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
        ],
        dialogVisible: false,
        jsonData: null,
        menuList: []
      };
    },
    watch: {
        queryParamsTime(v) {
            this.queryParams.startTime = moment(v[0]).format('YYYY-MM-DD') || moment(start).format('YYYY-MM-DD');
            this.queryParams.endTime = moment(v[1]).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD');
        },
    },
    mounted() {
      this._getMenus();
      this.$nextTick(() => {
        this.$refs.BjPage.pagingInfo.size = 100;
        this.$refs.BjPage.onSearch();
      });
    },
    methods: {
      beforeResetSearch() {
        this.queryParams = {
            startTime: moment(start).format('YYYY-MM-DD'),
            endTime: moment(new Date()).format('YYYY-MM-DD'),
            menu: '',
            invoiceId: '', transNo: '', clientCode: '', billingWeekStart: '', action: '', size: 100,
        };
        this.queryParamsTime = [start, new Date()];
        return new Promise(resolve => {
          resolve();
        });
      },
      _getMenus() {
        billApi.getMenus().then(res => {
          this.menuList = res.data;
        });
      },
      handleCancel() {
        this.dialogVisible = false;
      },
      onView(item) {
        this.jsonData = item.content || '';
        this.dialogVisible = true;
      }
    },
  };
  </script>
